export const contactsLinks = [
   { link: 'tel:+380635942909', label: '+38 (063) 594-29-09' },
   { link: 'mailto: sl7one@ukr.net', label: 'sl7one@ukr.net' },
   { link: 'https://t.me/sl7one', label: 'Telegram' },
   { link: 'https://www.linkedin.com/in/sl7one/', label: 'LinkedIn' },
   { link: 'https://github.com/sl7one', label: 'GitHub' },
];
